import { createContext, useState } from "react";

// Create the context
export const NavContext = createContext({
  navActive: false,
  toggleNavActive: () => {},
});

// Create a provider component
export const NavProvider = ({ children }) => {
  const [navActive, setNavActive] = useState(false);

  const toggleNavActive = () => {
    setNavActive((prevState) => !prevState); // Toggle the state
  };

  return (
    <NavContext.Provider value={{ navActive, toggleNavActive }}>
      {children}
    </NavContext.Provider>
  );
};
